import React, {useState, useEffect} from "react";
import Success from "../../Alerts/Success";
import Error from "../../Alerts/Error";

function Extensions() {
	const API_BASE = process.env.REACT_APP_endPoint;

  function connectXero(platform) {
    window.location.href = `${API_BASE}/v1/xero/connect?platform=${platform}`;
  }

  function getConnections() {
    fetch(`${API_BASE}/v1/xero/connections`, { credentials: 'include' })
      .then(response => response.json())
      .then(data => {
        if (!data.error) {
          setConnections(data);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  useEffect(() => {
    getConnections();
  }, []);

  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [connections, setConnections] = useState([]);

  const usConnection = connections?.some(connection => connection.platform_id === 1);
  const caConnection = connections?.some(connection => connection.platform_id === 2);

  useEffect(() => {
      const p = new URLSearchParams(window.location.search);
      const status = p.get('xero');
      if (status === 'connected') {
        setSuccess(`Connected ${p.get('org')} to ${p.get('platform')}`);
      } else if (status === 'error') {
        setError(`Xero connect failed: ${p.get('reason')} ${p.get('message') || ''}`);
      }
      if (status) window.history.replaceState({}, '', window.location.pathname);
  }, []);

	return(
		<>
			<h3>Extensions</h3>
			<p>Connect your Xero account to your account</p>
      {success && <Success message={success} />}
      {error && <Error message={error} />}
			<button className="btn btn-primary" disabled={usConnection} style={{marginRight: '10px'}} onClick={() => connectXero('US')}>{usConnection ? 'Already connected to Xero (US)' : 'Connect Xero (US)'}</button>
			<button className="btn btn-primary" disabled={caConnection} onClick={() => connectXero('CA')}>{caConnection ? 'Already connected to Xero (CA)' : 'Connect Xero (CA)'}</button>
		</>
	);
}

export default Extensions;